import React from 'react';
import styles from '../CommandPalette.module.scss';

export type ChipVariant = 'experimental' | 'new' | 'context' | 'error' | 'warning' | 'info';

interface ChipConfig {
  label: string;
  variant: ChipVariant;
}

const variantStyleMap: Record<ChipVariant, string> = {
  experimental: styles.keywordChipExperimental,
  new: styles.keywordChipNew,
  context: styles.keywordChipContext,
  error: styles.keywordChipError,
  warning: styles.keywordChipWarning,
  info: styles.keywordChipInfo,
};

interface ChipProps {
  label: string;
  variant: ChipVariant;
}

export const Chip: React.FC<ChipProps> = ({ label, variant }) => (
  <span className={`${styles.keywordChip} ${variantStyleMap[variant]}`}>
    {label}
  </span>
);

function getChipConfig(keyword: string): ChipConfig | null {
  switch (keyword.toLowerCase()) {
    case 'experimental':
      return { label: 'experimental', variant: 'experimental' };
    case 'new!':
      return { label: 'new!', variant: 'new' };
    case 'error':
      return { label: 'error', variant: 'error' };
    case 'warning':
      return { label: 'warning', variant: 'warning' };
    case 'info':
      return { label: 'info', variant: 'info' };
    default:
      return null;
  }
}

interface KeywordChipsProps {
  keywords?: string[];
}

export const KeywordChips: React.FC<KeywordChipsProps> = ({ keywords }) => {
  if (!keywords?.length) return null;

  const chips = keywords.reduce<ChipConfig[]>((acc, kw) => {
    const config = getChipConfig(kw);
    if (config) acc.push(config);
    return acc;
  }, []);

  if (!chips.length) return null;

  return (
    <>
      {chips.map((chip) => (
        <span
          key={chip.variant}
          className={`${styles.keywordChip} ${variantStyleMap[chip.variant]}`}
        >
          {chip.label}
        </span>
      ))}
    </>
  );
};
